// DAS-2124: Replaced modal with navigation to /portfolio_analysis
import React from 'react';
import { Button } from 'antd';
import { PieChartOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from '../functions/api';
import './AboutModal.css';

const AboutModal = () => {
  const navigate = useNavigate();
  const userId = useSelector((state) => state.auth.userId);

  const handleClick = () => {
    api.post('/visitor_about_click', {
      source: 'portfolio_analysis_button',
      user_id: userId || null,
      language: navigator.language || 'unknown',
      screen: `${window.screen.width}x${window.screen.height}`,
      referrer: document.referrer || '',
      page_url: window.location.href,
    }).catch(() => {});
    navigate('/portfolio_analysis');
  };

  return (
    <Button 
      onClick={handleClick}
      className="about-button"
      size="small"
      icon={<PieChartOutlined />}
    >
      Have your Portfolio analysed
    </Button>
  );
};

export default AboutModal;
